import React from "react";
import ReactDOM from "react-dom";
import App from "app/App";
import * as serviceWorker from "./serviceWorker";
import Provider from "store/configureStore";

ReactDOM.render(<Provider children={<App />} />, document.getElementById("root"));

serviceWorker.unregister();
